import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import Button from '@/components/ui/Button';

export default function SubscriptionFailure() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-cream-50 p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg border border-cream-200 p-8 text-center">
        <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
          <XCircle className="h-10 w-10 text-red-600" />
        </div>
        <h1 className="text-2xl font-bold text-taupe-900 mb-2">Activación cancelada</h1>
        <p className="text-taupe-600 mb-6">
          No se pudo completar la autorización en Mercado Pago. Podés volver a intentarlo desde Facturación.
        </p>
        <Link to="/dashboard/billing">
          <Button className="w-full bg-taupe-700 hover:bg-taupe-800 text-cream-50">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Volver a Facturación
          </Button>
        </Link>
      </div>
    </div>
  );
}
